<template>
  <main>
    <Navbar />

    <v-main class="mainContainer">
      <v-container>
        <transition name="slide" mode="out-in">
          <router-view></router-view>
        </transition>
      </v-container>
    </v-main>

    <SidebarRight />
  </main>
</template>

<script>
import Navbar from "@/components/layouts/navbar/Navbar.vue";
import SidebarRight from "@/components/layouts/sidebar/SidebarRight.vue";

export default {
  name: "ViewContainer",

  components: {
    Navbar,
    SidebarRight,
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/_variables.scss";

.mainContainer {
  min-height: 100vh;
  height: 100%;
  background: $bg-color;

  .container {
    height: 100%;
    padding: 20px !important;

    .slide-enter,
    .slide-leave-to {
      transform: translate(-50px);
      opacity: 0;
    }

    .slide-enter-active,
    .slide-leave-active {
      transition: all 0.3s;
    }
  }
}
</style>
